<div class="list-content" [hidden]="!propertyList">
  <div class="row">
    <div class="col-lg-4 col-md-4 col-sm-6 col-12 px-3 pt-3" *ngFor="let property of propertyList; let i = index">
      <div class="list_card">
        <div
          class="row align-items-center"
          role="button"
          (keydown.enter)="getDetails(property); $event.stopPropagation()"
          (click)="getDetails(property); $event.stopPropagation()"
          tabindex="10"
        >
          <!-- Image Column -->
          <div class="col-4 proplist_imgWrap d-flex align-items-center pr-0">
            <span style="color: transparent; position: absolute; top: 0">{{ property.Address }}</span>

            <img
              class="img-fluid p-2"
              [src]="
                property.imgUrl
                  ? property.imgUrl
                  : listingImageBaseUrl + '?ListingId=' + (property.ListingId || 'null') + '&imageName=1&height=219'
              "
              alt="Property Image"
              style="height: 70px; object-fit: cover; width: 100%"
            />

            <!-- <ng-container *ngIf="property.ImageURLs">
              <img class="img-fluid mx-auto p-2" [src]="property.ImageURLs" />
            </ng-container> -->

            <!-- <ng-container *ngIf="!property.ImageURLs && property.isStreetViewAvailable !== false">
              <div class="p-md-3">
                <app-street-view
                  [defaultPlace]="getDefaultPlace(property)"
                  [isMyHomeAccess]="true"
                  (streetViewAvailable)="onStreetViewAvailable($event)"
                  [containerHeight]="'120'"
                >
                </app-street-view>
              </div>
            </ng-container>
            <ng-container *ngIf="!property.ImageURLs && property.isStreetViewAvailable === false">
              <div class="p-md-3">
                <app-birds-eye-view [defaultPlace]="getDefaultPlace(property)" [containerHeight]="'54'">
                </app-birds-eye-view>
              </div>
            </ng-container> -->
          </div>

          <!-- Address Column -->
          <div class="col-8 pl-0">
            <h5 class="prop-address">{{ property.StreetAddress }}</h5>
            <p class="sub-address text-muted mb-0">
              {{ property.City }}, {{ property.StateOrProvince }} {{ property.PostalCode }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <mat-paginator
    *ngIf="cmaState.listPropertySetCount"
    class="my-4 pagination only-nav-buttons"
    [length]="cmaState.listPropertySetCount"
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    hidePageSize="true"
    (page)="onPageChange($event)"
    showFirstLastButtons
  >
  </mat-paginator>
</div>
